<template>
  <div>
    <label v-if="label" class="select-none flex items-center w-full" :for="id">
        <input :id="id" :name="id" type="checkbox" :value="value" v-model="proxyChecked" :checked="proxyChecked" :disabled="disabled"
          @change="$emit('input', $event.target.checked)"
          class="mr-2 rounded border-gray-300 text-shtax-600 shadow-sm focus:border-shtax-300 focus:ring focus:ring-shtax-200 focus:ring-opacity-50 checked:bg-shtax-600 checked:border-transparent disabled:bg-shtax-100">
        <span class="text-sm">{{ label }}</span>
    </label>
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
export default {
    emits: ['update:checked'],

    props: {
        id: {
          type: String,
          default() {
            return `cb-${this._uid}`
          },
        },
        checked: {
            type: Boolean,
            default: false,
        },
        value: {
            default: null,
        },
        label: String,
        error: String,
        disabled: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        proxyChecked: {
            get() {
                return this.checked;
            },

            set(val) {
                this.$emit("update:checked", val);
            },
        },
    },
}
</script>